import { render, staticRenderFns } from "./RadioButtonQuestion.vue?vue&type=template&id=40fecd31&scoped=true&"
import script from "./RadioButtonQuestion.vue?vue&type=script&lang=js&"
export * from "./RadioButtonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonQuestion.vue?vue&type=style&index=0&id=40fecd31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fecd31",
  null
  
)

export default component.exports